export function termsConditionListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      adminMarkets: resource.markets.map((item) => ({markets : item})),
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateTermsConditionId(json) {
  return {
    data: {...json.result, id: json.result.objectId},
  };
}

export function fixCreateTermsConditionId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function termsConditionMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId,
      adminMarkets: json.result.markets.map((item) => ({markets : item})),
    },
  };
}